import CustomerService from "../../services/CustomerService";
import { useState, useRef, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { notification } from "antd";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js/dist/html2pdf.min";
import ReactDOMServer from "react-dom/server";
import RegisterationDocument from "../agreements/RegisterationDocument";
import Lodder from "../../components/Lodder";
import customerServices from "../../services/CustomerService";
import { Select } from "antd";
import { State } from "country-state-city";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import PaymentService from "../../services/PaymentService";
import ServicesService from "../../services/ServicesService";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { CloseOutlined } from "@ant-design/icons";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../../components/CheckoutForm/CheckoutForm";
import Navbar from "../common/Navbar";
import api from "../../configuration/ApiConfig";
import ContactUs from "../common/ContactUs";
import Footer from "../common/Footer";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const fieldStyles = {
  border: "1px solid rgb(255, 255, 255)",
  "border-radius": "0.25rem",
  color: "rgb(26, 32, 44)",
  "font-weight": 400,
  height: "38px",
  width: "100%",
  "font-size": "14px",
  padding: "6px 12px",
};

const Register = () => {
  const stripePromise = loadStripe(
    "pk_test_51RZCgfQrbbv11ZwdbvxouEPilnlylGHq0YnkrTqu6MpzPXnO2vbkNsujw2a9MzbmnCNDuSF3ZHqiyAeiedQT4fUt00wxMPdvGo"
  );

  // State Initialization
  const [showPassword, setShowPassword] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [customer, setCustomer] = useState({});
  const [showLodder, setShowLodder] = useState(false);
  const [customerId, setCustomerId] = useState(0);
  const [model, setModal] = useState(false);
  const [login, setLogin] = useState(false);
  const [isLogined, setIsLogined] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const navigate = useNavigate();
  const [signature, setSignature] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [customerFirstName, setCustomerFirstName] = useState("");
  const [customerLastName, setCustomerLastName] = useState("");
  const [email, setEmail] = useState("");
  const [signFirstName, setSignFirstName] = useState("");
  const [signLastName, setSignLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [agreementAccepted, setAgreementAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [showAccountSection, setShowAccountSection] = useState(false);
  const accountSectionRef = useRef(null);
  const agreementSectionRef = useRef(null);

  // Track touched fields
  const [touched, setTouched] = useState({
    businessName: false,
    addressLine1: false,
    addressLine2: false,
    city: false,
    state: false,
    zipCode: false,
    customerFirstName: false,
    customerLastName: false,
    email: false,
    signFirstName: false,
    signLastName: false,
    password: false,
    confirmPassword: false,
    signature: false,
    agreementAccepted: false,
    termsAccepted: false,
    loginPassword: false,
  });

  // Validation states
  const [businessNameValidation, setBusinessNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [addressLine1Validation, setAddressLine1Validation] = useState({
    isValid: true,
    message: "",
  });
  const [addressLine2Validation, setAddressLine2Validation] = useState({
    isValid: true,
    message: "",
  });
  const [cityValidation, setCityValidation] = useState({
    isValid: true,
    message: "",
  });
  const [stateValidation, setStateValidation] = useState({
    isValid: true,
    message: "",
  });
  const [zipCodeValidation, setZipCodeValidation] = useState({
    isValid: true,
    message: "",
  });
  const [customerFirstNameValidation, setCustomerFirstNameValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const [customerLastNameValidation, setCustomerLastNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [emailValidation, setEmailValidation] = useState({
    isValid: true,
    message: "",
  });
  const [signFirstNameValidation, setSignFirstNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [signLastNameValidation, setSignLastNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: true,
    message: "",
  });
  const [confirmPasswordValidation, setConfirmPasswordValidation] = useState({
    isValid: true,
    message: "",
  });
  const [signatureValidation, setSignatureValidation] = useState({
    isValid: false,
    message: "",
  });
  const [passwordLoginValidation, setLoginPasswordValidation] = useState({
    isValid: true,
    message: "",
  });
  const [agreementValidation, setAgreementValidation] = useState({
    isValid: true,
    message: "",
  });
  const [termsValidation, setTermsValidation] = useState({
    isValid: true,
    message: "",
  });

  // Validation Functions
  const ValidateBusinessName = (value) => {
    if (value.length > 100) {
      setBusinessNameValidation({
        isValid: false,
        message: "Business name not more than 100 character",
      });
      return false;
    } else {
      setBusinessNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateAddressLine1 = (value) => {
    if (!value.trim()) {
      setAddressLine1Validation({
        isValid: false,
        message: "Address line 1 is required",
      });
      return false;
    } else if (value.length > 100) {
      setAddressLine1Validation({
        isValid: false,
        message: "Address line 1 not more than 100 character",
      });
      return false;
    } else {
      setAddressLine1Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateAddressLine2 = (value) => {
    if (value.length > 100) {
      setAddressLine2Validation({
        isValid: false,
        message: "Address line 2 not more than 100 character",
      });
      return false;
    } else {
      setAddressLine2Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateCity = (value) => {
    if (!value.trim()) {
      setCityValidation({
        isValid: false,
        message: "City is required",
      });
      return false;
    } else if (value.length > 100) {
      setCityValidation({
        isValid: false,
        message: "City not more than 100 character",
      });
      return false;
    } else {
      setCityValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateState = (value) => {
    if (!value.trim()) {
      setStateValidation({
        isValid: false,
        message: "State is required",
      });
      return false;
    } else if (value.length > 100) {
      setStateValidation({
        isValid: false,
        message: "State not more than 100 character",
      });
      return false;
    } else {
      setStateValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateZipCode = (value) => {
    if (!value.trim()) {
      setZipCodeValidation({
        isValid: false,
        message: "Zip code is required",
      });
      return false;
    } else if (value.length !== 5) {
      setZipCodeValidation({
        isValid: false,
        message: "Please enter a valid zip code",
      });
      return false;
    } else {
      setZipCodeValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateCustomerFirstName = (value) => {
    if (!value.trim()) {
      setCustomerFirstNameValidation({
        isValid: false,
        message: "First name is required",
      });
      return false;
    } else if (value.length > 50) {
      setCustomerFirstNameValidation({
        isValid: false,
        message: "First name not more than 50 character",
      });
      return false;
    } else {
      setCustomerFirstNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateCustomerLastName = (value) => {
    if (!value.trim()) {
      setCustomerLastNameValidation({
        isValid: false,
        message: "Last name is required",
      });
      return false;
    } else if (value.length > 50) {
      setCustomerLastNameValidation({
        isValid: false,
        message: "Last name not more than 50 character",
      });
      return false;
    } else {
      setCustomerLastNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateSignFirstName = (value) => {
    if (!value.trim()) {
      setSignFirstNameValidation({
        isValid: false,
        message: "First name is required",
      });
      return false;
    } else if (value.length > 50) {
      setSignFirstNameValidation({
        isValid: false,
        message: "First name not more than 50 character",
      });
      return false;
    } else {
      setSignFirstNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateSignLastName = (value) => {
    if (!value.trim()) {
      setSignLastNameValidation({
        isValid: false,
        message: "Last name is required",
      });
      return false;
    } else if (value.length > 50) {
      setSignLastNameValidation({
        isValid: false,
        message: "Last name not more than 50 character",
      });
      return false;
    } else {
      setSignLastNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const IsValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const ValidateEmail = (value) => {
    if (!value.trim()) {
      setEmailValidation({ isValid: false, message: "Email is required" });
      return false;
    } else if (value.length > 100) {
      setEmailValidation({
        isValid: false,
        message: "Email not more than 100 character",
      });
      return false;
    } else if (!IsValidEmail(value)) {
      setEmailValidation({
        isValid: false,
        message: "Please enter a valid email",
      });
      return false;
    } else {
      setEmailValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidatePassword = (value) => {
    if (!value.trim()) {
      setPasswordValidation({
        isValid: false,
        message: "Password is required",
      });
      return false;
    } else if (value.length < 6) {
      setPasswordValidation({
        isValid: false,
        message: "Please enter a minimum of 6 characters",
      });
      return false;
    } else {
      setPasswordValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateConfirmPassword = (value) => {
    if (!value.trim()) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "Confirm password is required",
      });
      return false;
    } else if (value !== password) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "Password and confirm password must be same",
      });
      return false;
    } else {
      setConfirmPasswordValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateLoginPassword = (value) => {
    if (!value.trim()) {
      setLoginPasswordValidation({
        isValid: false,
        message: "Password is required",
      });
      return false;
    } else {
      setLoginPasswordValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateSignature = (isBlur = false) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    let hasSignature = false;
    for (let i = 0; i < imageData.data.length; i += 4) {
      if (imageData.data[i + 3] !== 0) {
        hasSignature = true;
        break;
      }
    }

    if (hasSignature) {
      setSignatureValidation({
        isValid: true,
        message: "",
      });
      return true;
    }

    setSignatureValidation({
      isValid: false,
      message: isBlur ? "Signature is required" : "",
    });
    return false;
  };

  const ValidateAgreementCheckbox = (isChecked) => {
    if (!isChecked) {
      setAgreementValidation({
        isValid: false,
        message: "You must accept the Engagement Agreement",
      });
      return false;
    } else {
      setAgreementValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateTermsCheckbox = (isChecked) => {
    if (!isChecked) {
      setTermsValidation({
        isValid: false,
        message: "You must accept the Terms and Conditions",
      });
      return false;
    } else {
      setTermsValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  // Field Change and Blur Handlers
  const handleBusinessNameChange = (event) => {
    setBusinessName(event.target.value);
  };

  const handleBusinessNameBlur = () => {
    setTouched((prev) => ({ ...prev, businessName: true }));
    ValidateBusinessName(businessName);
  };

  const handleAddressLine1Change = (event) => {
    setAddressLine1(event.target.value);
  };

  const handleAddressLine1Blur = () => {
    setTouched((prev) => ({ ...prev, addressLine1: true }));
    ValidateAddressLine1(addressLine1);
  };

  const handleAddressLine2Change = (event) => {
    setAddressLine2(event.target.value);
  };

  const handleAddressLine2Blur = () => {
    setTouched((prev) => ({ ...prev, addressLine2: true }));
    ValidateAddressLine2(addressLine2);
  };

  const handleCityChange = (event) => {
    setCity(event.target.value);
  };

  const handleCityBlur = () => {
    setTouched((prev) => ({ ...prev, city: true }));
    ValidateCity(city);
  };

  const handleStateChange = (selectedOption) => {
    setState(selectedOption);
  };

  const handleStateBlur = () => {
    setTouched((prev) => ({ ...prev, state: true }));
    ValidateState(state);
  };

  const handleZipCodeChange = (event) => {
    setZipCode(event.target.value);
  };

  const handleZipCodeBlur = () => {
    setTouched((prev) => ({ ...prev, zipCode: true }));
    ValidateZipCode(zipCode);
  };

  const handleCustomerFirstNameChange = (event) => {
    setCustomerFirstName(event.target.value);
  };

  const handleCustomerFirstNameBlur = () => {
    setTouched((prev) => ({ ...prev, customerFirstName: true }));
    ValidateCustomerFirstName(customerFirstName);
  };

  const handleCustomerLastNameChange = (event) => {
    setCustomerLastName(event.target.value);
  };

  const handleCustomerLastNameBlur = () => {
    setTouched((prev) => ({ ...prev, customerLastName: true }));
    ValidateCustomerLastName(customerLastName);
  };

  const validateAllFields = () => {
    const isBusinessNameValid = ValidateBusinessName(businessName);
    const isCustomerFirstNameValid =
      ValidateCustomerFirstName(customerFirstName);
    const isCustomerLastNameValid = ValidateCustomerLastName(customerLastName);
    const isAddressLine1Valid = ValidateAddressLine1(addressLine1);
    const isAddressLine2Valid = ValidateAddressLine2(addressLine2);
    const isCityValid = ValidateCity(city);
    const isStateValid = ValidateState(state);
    const isZipCodeValid = ValidateZipCode(zipCode);

    return (
      isBusinessNameValid &&
      isCustomerFirstNameValid &&
      isCustomerLastNameValid &&
      isAddressLine1Valid &&
      isAddressLine2Valid &&
      isCityValid &&
      isStateValid &&
      isZipCodeValid
    );
  };

  const handleNextClick = () => {
    setTouched((prev) => ({
      ...prev,
      businessName: true,
      customerFirstName: true,
      customerLastName: true,
      addressLine1: true,
      addressLine2: true,
      city: true,
      state: true,
      zipCode: true,
    }));

    const allFieldsValid = validateAllFields();

    if (allFieldsValid) {
      setShowAccountSection(true);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 0);
    } else {
      notification.error({
        message: "Please fill all required fields correctly",
      });
    }
  };

  const handleBackClick = () => {
    setShowAccountSection(false);
    setAgreementAccepted(false);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const handleAgreementAccept = (event) => {
    const isChecked = event.target.checked;
    setAgreementAccepted(isChecked);
    setTouched((prev) => ({ ...prev, agreementAccepted: true }));
    ValidateAgreementCheckbox(isChecked);
    if (isChecked && agreementSectionRef.current) {
      setTimeout(() => {
        agreementSectionRef.current.scrollIntoView({ behavior: "smooth" });
      }, 0);
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleEmailBlur = () => {
    setTouched((prev) => ({ ...prev, email: true }));
    ValidateEmail(email);
    if (IsValidEmail(email)) {
      setShowLodder(true);
      customerServices
        .CheckCustomerExist(email)
        .then((response) => {
          if (response.status && response.resultData > 0) {
            setModal(true);
          }
        })
        .catch((error) => {
          notification.error({
            message: error.response?.data?.Message || "An error occurred",
          });
        })
        .finally(() => {
          setShowLodder(false);
        });
    }
  };

  const handleSignFirstNameChange = (event) => {
    setSignFirstName(event.target.value);
  };

  const handleSignFirstNameBlur = () => {
    setTouched((prev) => ({ ...prev, signFirstName: true }));
    ValidateSignFirstName(signFirstName);
  };

  const handleSignLastNameChange = (event) => {
    setSignLastName(event.target.value);
  };

  const handleSignLastNameBlur = () => {
    setTouched((prev) => ({ ...prev, signLastName: true }));
    ValidateSignLastName(signLastName);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (confirmPassword && touched.confirmPassword) {
      ValidateConfirmPassword(confirmPassword);
    }
  };

  const handlePasswordBlur = () => {
    setTouched((prev) => ({ ...prev, password: true }));
    ValidatePassword(password);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleConfirmPasswordBlur = () => {
    setTouched((prev) => ({ ...prev, confirmPassword: true }));
    ValidateConfirmPassword(confirmPassword);
  };

  const handleLoginPasswordChange = (event) => {
    setLoginPassword(event.target.value);
  };

  const handleLoginPasswordBlur = () => {
    setTouched((prev) => ({ ...prev, loginPassword: true }));
    ValidateLoginPassword(loginPassword);
  };

  const handleTermsCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setTermsAccepted(isChecked);
    setTouched((prev) => ({ ...prev, termsAccepted: true }));
    ValidateTermsCheckbox(isChecked);
  };

  const handleAutoSubmit = (event) => {
    debugger;
    if (event) event.preventDefault();
    ValidateEmail(email);
    ValidateSignFirstName(signFirstName);
    ValidateSignLastName(signLastName);
    ValidateSignature(signature);
    if (emailValidation.isValid) {
      const customer = {
        customerFirstName,
        customerLastName,
        businessName,
        email,
        addressLine1,
        addressLine2,
        city,
        state,
        zipCode,
        signature: signature.split(",")[1] || "",
        signFirstName,
        signLastName,
        password,
      };
      CustomerService.Register(customer).catch((error) => {});
    }
  };

  // Form Submission
  const handleFormSubmit = (event) => {
    event.preventDefault();

    setTouched({
      businessName: true,
      addressLine1: true,
      addressLine2: true,
      city: true,
      state: true,
      zipCode: true,
      customerFirstName: true,
      customerLastName: true,
      email: true,
      signFirstName: true,
      signLastName: true,
      password: true,
      confirmPassword: true,
      signature: true,
      agreementAccepted: true,
      termsAccepted: true,
    });

    const isBusinessNameValid = ValidateBusinessName(businessName);
    const isCustomerFirstNameValid =
      ValidateCustomerFirstName(customerFirstName);
    const isCustomerLastNameValid = ValidateCustomerLastName(customerLastName);
    const isEmailValid = ValidateEmail(email);
    const isAddressLine1Valid = ValidateAddressLine1(addressLine1);
    const isAddressLine2Valid = ValidateAddressLine2(addressLine2);
    const isCityValid = ValidateCity(city);
    const isStateValid = ValidateState(state);
    const isZipCodeValid = ValidateZipCode(zipCode);
    const isSignFirstNameValid = ValidateSignFirstName(signFirstName);
    const isSignLastNameValid = ValidateSignLastName(signLastName);
    const isPasswordValid = ValidatePassword(password);
    const isConfirmPasswordValid = ValidateConfirmPassword(confirmPassword);
    const isSignatureValid = ValidateSignature(true);
    const isAgreementValid = ValidateAgreementCheckbox(agreementAccepted);
    const isTermsValid = ValidateTermsCheckbox(termsAccepted);

    if (
      isBusinessNameValid &&
      isCustomerFirstNameValid &&
      isCustomerLastNameValid &&
      isEmailValid &&
      isAddressLine1Valid &&
      isAddressLine2Valid &&
      isCityValid &&
      isStateValid &&
      isZipCodeValid &&
      isSignFirstNameValid &&
      isSignLastNameValid &&
      isPasswordValid &&
      isConfirmPasswordValid &&
      isSignatureValid &&
      isAgreementValid &&
      isTermsValid
    ) {
      setCustomer({
        customerId,
        customerFirstName,
        customerLastName,
        businessName,
        email,
        addressLine1,
        addressLine2,
        city,
        state,
        zipCode,
        signature: signature.split(",")[1] || "",
        signFirstName,
        signLastName,
        password,
      });
      const data = {
        customerId,
        customerFirstName,
        customerLastName,
        businessName,
        email,
        addressLine1,
        addressLine2,
        city,
        state,
        zipCode,
        signature,
        signFirstName,
        signLastName,
        password,
        isPayment: true,
        isLogined,
      };
      localStorage.setItem("Data", JSON.stringify(data));
      setShowLodder(true);
      handleAutoSubmit();
      customerServices
        .CheckBusinessExist(email, businessName)
        .then(async (response) => {
          if (response.status && response.resultData > 0) {
            notification.error({
              message: "You already take same service for this business",
            });
            setShowLodder(false);
          } else {
            const secret = await fetchClientSecret();
            setClientSecret(secret);
            setIsPayment(true);
            setShowLodder(false);
          }
        })
        .catch((error) => {
          notification.error({
            message: error.response?.data?.Message || "An error occurred",
          });
          setShowLodder(false);
        });
    }
  };

  const fetchClientSecret = async () => {
    const response = await api.post("Customers/CreateSubscription", {
      customerEmail: email,
      priceId: "price_1RZSJIQrbbv11ZwdFAMSgtZC",
    });
    return response.data;
  };

  const handleLoginFormSubmit = () => {
    setTouched((prev) => ({ ...prev, loginPassword: true }));
    const isLoginPasswordValid = ValidateLoginPassword(loginPassword);
    if (isLoginPasswordValid) {
      const customerCredentials = {
        email,
        password: loginPassword,
      };
      CustomerService.LoginCustomerForAddingNewBusiness(customerCredentials)
        .then((response) => {
          if (response.status) {
            setIsLogined(true);
            const userId = response.resultData;
            setCustomerId(userId);
            setLogin(false);
            customerServices
              .GetCustomerById(userId)
              .then((response) => {
                if (response.status) {
                  const { resultData } = response;
                  if (resultData !== null) {
                    setCustomerFirstName(resultData.customerFirstName);
                    setCustomerLastName(resultData.customerLastName);
                    setEmail(resultData.email);
                    setPassword(loginPassword);
                    setConfirmPassword(loginPassword);
                    setCustomerFirstNameValidation({
                      isValid: true,
                      message: "",
                    });
                    setCustomerLastNameValidation({
                      isValid: true,
                      message: "",
                    });
                    setEmailValidation({
                      isValid: true,
                      message: "",
                    });
                    setPasswordValidation({
                      isValid: true,
                      message: "",
                    });
                    setConfirmPasswordValidation({
                      isValid: true,
                      message: "",
                    });
                    setTouched((prev) => ({
                      ...prev,
                      customerFirstName: true,
                      customerLastName: true,
                      email: true,
                      password: true,
                      confirmPassword: true,
                    }));
                  }
                }
              })
              .catch((error) => {
                notification.error({
                  message: error.response.data.Message,
                });
              });
          }
        })
        .catch((error) => {
          notification.error({
            message: error.response.data.Message,
          });
        });
    }
  };

  // Signature Functions
  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 3;
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  // const endDrawing = () => {
  //   setIsDrawing(false);
  //   const canvas = canvasRef.current;
  //   const signatureData = canvas.toDataURL();
  //   setSignature(signatureData);
  //   setTouched((prev) => ({ ...prev, signature: true }));
  //   ValidateSignature();
  // };
  const endDrawing = () => {
    setIsDrawing(false);
    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL();
    setSignature(signatureData);
    // Validate but don't show message yet
    ValidateSignature();
  };

  const handleSignatureBlur = () => {
    setTouched((prev) => ({ ...prev, signature: true }));
    // Validate and show message if invalid
    ValidateSignature(true);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setSignature("");
    setSignatureValidation({
      isValid: false,
      message: touched.signature ? "Signature is required" : "",
    });
  };

  // Other Helper Functions
  const makeAgreement = (customer, resultData) => {
    const printElement = ReactDOMServer.renderToString(
      RegisterationDocument(customer)
    );
    const opt = {
      margin: [13, 0],
      filename: `RegistrationAgreement${resultData.customerBusinessId.customerBusinessId}.pdf`,
    };
    const pdf = html2pdf().from(printElement).set(opt);
    pdf
      .toPdf()
      .outputPdf("blob")
      .then((PDF) => {
        CustomerService.SaveRegisterationAgreement(
          PDF,
          `${resultData.customerBusinessId.customerBusinessId}`,
          `${resultData.customerBusinessId.customerServiceId}`
        );
      });
  };

  const showSuccessMsg = (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const usStates = State.getStatesOfCountry("US").map((state) => ({
    value: state.name,
    label: state.name,
  }));

  const handlelogin = () => {
    setModal(false);
    setLogin(true);
  };

  // Payment
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);
  const [feild, setFeild] = useState(true);
  const [amount, setAmount] = useState(301);
  const [paymentToken, setPaymentToken] = useState(null);
  const [fieldState, setFeildState] = useState(null);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("pop", "1");
    navigate("/dashboard");
  };

  const handleChange = (change) => {
    setFeildState(change.state);
  };

  window.gravityLegal.addChangeListener((event) => {
    console.log(event);
    if (event.type === "fields_loaded") {
      setFeild(false);
    }
    handleChange(event);
  });

  const handleBack = () => {
    setIsPayment(false);
    var image = new Image();
    image.src = signature;
    image.onload = function () {
      var canvas = canvasRef.current;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
    };
    setFeild(true);
  };

  const handlePaymentSubmit = (event) => {
    event.preventDefault();
    setShowLodder(true);
    if (fieldState?.initializing) {
      setShowLodder(false);
      return;
    }
    window.gravityLegal.submitFields(async (err) => {
      setShowLodder(true);
      if (err) {
        notification.error({
          message: `${err.fieldId} ${err.result}`,
        });
        setShowLodder(false);
        return;
      }
      setShowLodder(false);
    });
    setTimeout(() => {
      setShowLodder(false);
    }, 2000);
  };

  const handleAddCustomerSubmit = (event) => {
    event.preventDefault();
    if (fieldState?.initializing) {
      setShowLodder(false);
      return;
    }
    window.gravityLegal.submitFields(async (err) => {
      setShowLodder(true);
      if (err) {
        notification.error({
          message: `${err.fieldId} ${err.result}`,
        });
        setShowLodder(false);
        return;
      }
      customer.signature = signature;
      fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          setShowLodder(true);
          const ipAddress = data.ip;
          customer.ip = ipAddress;
          const printElement = ReactDOMServer.renderToString(
            RegisterationDocument(customer)
          );
          const opt = {
            margin: [13, 0],
          };
          const pdf = html2pdf().from(printElement).set(opt);
          pdf
            .toPdf()
            .outputPdf("blob")
            .then((PDF) => {
              customer.amount = amount;
              customer.paymentMethod = fieldState.paymentMethod;
              customer.paymentToken = paymentToken;
              CustomerService.RegisterCustomer(customer, PDF)
                .then((response) => {
                  if (response.status) {
                    const customerCredentials = {
                      email: customer.email,
                      password: customer.password,
                    };
                    CustomerService.LoginCustomer(customerCredentials)
                      .then((response) => {
                        localStorage.setItem(
                          "accessToken",
                          response.resultData.token
                        );
                        localStorage.setItem("pop", "1");
                        navigate("/dashboard");
                      })
                      .catch((error) => {
                        setShowLodder(false);
                        notification.error({
                          message: error.response.data.Message,
                        });
                      });
                  }
                })
                .catch((error) => {
                  setShowLodder(false);
                  console.log(error);
                });
            });
        })
        .catch((error) => {
          setShowLodder(false);
          console.error("Error fetching IP address:", error);
        });
    });
  };

  useEffect(() => {
    document.title = "Register";
    if (localStorage.getItem("Data")) {
      const data = JSON.parse(localStorage.getItem("Data"));
      setCustomer({
        customerId: data.customerId,
        customerFirstName: data.customerFirstName,
        customerLastName: data.customerLastName,
        businessName: data.businessName,
        email: data.email,
        addressLine1: data.addressLine1,
        addressLine2: data.addressLine2,
        city: data.city,
        state: state,
        zipCode: data.zipCode,
        signFirstName: data.signFirstName,
        signLastName: data.signLastName,
        password: data.password,
      });
      setBusinessName(data.businessName);
      setAddressLine1(data.addressLine1);
      setAddressLine2(data.addressLine2);
      setState(data.state);
      setCity(data.city);
      setZipCode(data.zipCode);
      setCustomerFirstName(data.customerFirstName);
      setCustomerLastName(data.customerLastName);
      setEmail(data.email);
      setSignFirstName(data.signFirstName);
      setSignLastName(data.signLastName);
      setSignature(data.signature);
      setPassword(data.password);
      setConfirmPassword(data.password);
      setCustomerId(data.customerId);
      setIsLogined(data.isLogined);
      if (!data.isPayment) {
        var image = new Image();
        image.src = signature;
        image.onload = function () {
          var canvas = canvasRef.current;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0);
          localStorage.removeItem("Data");
        };
      }
    }
  }, []);

  // useEffect(() => {
  //   if (isPayment) {
  //     window.scrollTo(0, 0);
  //     PaymentService.CreatePaymentToken().then((response) => {
  //       setPaymentToken(response);
  //     });
  //     ServicesService.GetServiceByServiceName(2)
  //       .then((response) => {
  //         if (response.status) {
  //           setAmount(Math.floor(response.resultData.price));
  //         }
  //       })
  //       .catch((error) => {
  //         notification.error({
  //           message: error.response.data.Message,
  //         });
  //       });
  //   }
  // }, [isPayment]);

  // Scroll to account section when it appears
  useEffect(() => {
    if (agreementAccepted && accountSectionRef.current) {
      setTimeout(() => {
        accountSectionRef.current.scrollIntoView({ behavior: "smooth" });
      }, 0);
    }
  }, [agreementAccepted]);

  window.gravityLegal.addChangeListener((event) => {
    if (event.type === "fields_loaded") {
      setFeild(false);
    }
    handleChange(event);
  });

  const appearance = {
    theme: "flat",
    variables: {
      colorPrimary: "#2B6CB0",
      colorBackground: "#ffffff",
      colorText: "#2D3748",
      colorDanger: "#e53e3e",
      fontFamily: "Arial, sans-serif",
      spacingUnit: "6px",
      borderRadius: "6px",
    },
    rules: {
      ".Input": {
        border: "1px solid #CBD5E0",
        padding: "10px",
        backgroundColor: "#f7fafc",
      },
      ".Input:focus": {
        borderColor: "#2B6CB0",
      },
      ".Label": {
        fontWeight: "500",
      },
    },
  };

  return (
    <>
      <Navbar />
      <Lodder show={showLodder} />
      <ToastContainer />
      {isPayment && clientSecret ? (
        <main className="container my-5">
          <div className="row">
            <div className="col-md-6 px-5 py-2">
              <h2 className="fw-bold mb-1 display-3" id="main-font">
                What You Get
              </h2>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  Unlimited iMessage/WhatsApp to PDF conversions
                </li>
                <li className="list-group-item">Motion Drafting Toolkit</li>
                <li className="list-group-item">Discovery Automation Suite</li>
                <li className="list-group-item">
                  Calendar & Deadline Management
                </li>
                <li className="list-group-item">Exhibit Organization</li>
                <li className="list-group-item">Filing & Document Support</li>
                <li className="list-group-item">
                  Real-time Strategy Assistance
                </li>
                <li className="list-group-item">
                  Redline Review of Legal Documents
                </li>
                <li className="list-group-item">
                  PACER Integration & Case Mapping
                </li>
                <li className="list-group-item">
                  Pro Se Coaching & Human-AI Oversight
                </li>
                <li className="list-group-item">Weekly Case Summary Reports</li>
                <li className="list-group-item">
                  Ethical Complaint Draft Assistance
                </li>
                <li className="list-group-item">
                  Refund Eligibility After 6-Month Minimum
                </li>
              </ul>
            </div>
            <div className="col-md-6 px-4 py-4 bg-light shadow rounded">
              <h1 className="display-5" id="main-font">
                Payment of - ${amount}
              </h1>
              <Elements
                stripe={stripePromise}
                options={{ clientSecret, appearance }}
              >
                <CheckoutForm />
              </Elements>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12">
              <h3 className="fw-bold mx-4 mb-4 display-3" id="main-font">
                ProSlay vs Traditional Law Firm
              </h3>
              <table className="table table-bordered table-striped table-hover text-center">
                <thead className="table-secondary">
                  <tr>
                    <th id="main-font">Feature</th>
                    <th id="main-font">ProSlay (${amount}/mo)</th>
                    <th id="main-font">Traditional Law Firm ($700/hr)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Unlimited Messaging to PDF</td>
                    <td>✔</td>
                    <td>✘</td>
                  </tr>
                  <tr>
                    <td>Automated Motion Drafting</td>
                    <td>✔</td>
                    <td>✘</td>
                  </tr>
                  <tr>
                    <td>Discovery Tools</td>
                    <td>✔</td>
                    <td>✘</td>
                  </tr>
                  <tr>
                    <td>Calendar & Deadline Tracker</td>
                    <td>✔</td>
                    <td>✘</td>
                  </tr>
                  <tr>
                    <td>Exhibit Numbering</td>
                    <td>✔</td>
                    <td>✘</td>
                  </tr>
                  <tr>
                    <td>Real-Time Filing Support</td>
                    <td>✔</td>
                    <td>✘</td>
                  </tr>
                  <tr>
                    <td>Refund Guarantee</td>
                    <td>✔ (After 6 months)</td>
                    <td>✘</td>
                  </tr>
                  <tr>
                    <td>Real Human Support</td>
                    <td>✔</td>
                    <td>✔ (billed)</td>
                  </tr>
                  <tr>
                    <td>Full Case Coverage</td>
                    <td>✔</td>
                    <td>$5,000–$25,000+</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </main>
      ) : (
        <div className="container mt-5 pt-2">
          <div className="row">
            <div className="col-lg-10 mx-auto mt-5">
              {!showAccountSection && (
                <div className="text-center mb-4">
                  <h3 className="display-4" id="main-font">
                    Create your account here
                  </h3>
                  <p className="display-5" id="main-font">
                    Please enter your information below
                  </p>
                </div>
              )}
              <form className="row form-main" onSubmit={handleFormSubmit}>
                {!showAccountSection ? (
                  // Step 1: Basic Details
                  <>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="customerFirstName" className="form-label">
                        First Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="customerFirstName"
                        value={customerFirstName}
                        onChange={handleCustomerFirstNameChange}
                        onBlur={handleCustomerFirstNameBlur}
                        disabled={isLogined}
                      />
                      {touched.customerFirstName &&
                        !customerFirstNameValidation.isValid && (
                          <span style={{ color: "red" }}>
                            {customerFirstNameValidation.message}
                          </span>
                        )}
                    </div>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="customerLastName" className="form-label">
                        Last Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="customerLastName"
                        value={customerLastName}
                        onChange={handleCustomerLastNameChange}
                        onBlur={handleCustomerLastNameBlur}
                        disabled={isLogined}
                      />
                      {touched.customerLastName &&
                        !customerLastNameValidation.isValid && (
                          <span style={{ color: "red" }}>
                            {customerLastNameValidation.message}
                          </span>
                        )}
                    </div>
                    <div className="col-lg-12 mb-3">
                      <label htmlFor="businessName" className="form-label">
                        Business Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="businessName"
                        value={businessName}
                        onChange={handleBusinessNameChange}
                        onBlur={handleBusinessNameBlur}
                      />
                      {touched.businessName &&
                        !businessNameValidation.isValid && (
                          <span style={{ color: "red" }}>
                            {businessNameValidation.message}
                          </span>
                        )}
                    </div>
                    <h6 className="ps-2 form-label">Address</h6>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="addressLine1" className="form-label">
                        Address Line 1<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="addressLine1"
                        value={addressLine1}
                        onChange={handleAddressLine1Change}
                        onBlur={handleAddressLine1Blur}
                      />
                      {touched.addressLine1 &&
                        !addressLine1Validation.isValid && (
                          <span style={{ color: "red" }}>
                            {addressLine1Validation.message}
                          </span>
                        )}
                    </div>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="addressLine2" className="form-label">
                        Address Line 2
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="addressLine2"
                        value={addressLine2}
                        onChange={handleAddressLine2Change}
                        onBlur={handleAddressLine2Blur}
                      />
                      {touched.addressLine2 &&
                        !addressLine2Validation.isValid && (
                          <span style={{ color: "red" }}>
                            {addressLine2Validation.message}
                          </span>
                        )}
                    </div>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="state" className="form-label">
                        State<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        className=""
                        id="state"
                        value={state || undefined}
                        onChange={handleStateChange}
                        onBlur={handleStateBlur}
                        options={usStates}
                        placeholder="Select a state"
                      />
                      {touched.state && !stateValidation.isValid && (
                        <span style={{ color: "red" }}>
                          {stateValidation.message}
                        </span>
                      )}
                    </div>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="city" className="form-label">
                        City<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        value={city}
                        onChange={handleCityChange}
                        onBlur={handleCityBlur}
                      />
                      {touched.city && !cityValidation.isValid && (
                        <span style={{ color: "red" }}>
                          {cityValidation.message}
                        </span>
                      )}
                    </div>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="zipCode" className="form-label">
                        ZIP Code<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="zipCode"
                        value={zipCode}
                        onChange={handleZipCodeChange}
                        onBlur={handleZipCodeBlur}
                      />
                      {touched.zipCode && !zipCodeValidation.isValid && (
                        <span style={{ color: "red" }}>
                          {zipCodeValidation.message}
                        </span>
                      )}
                    </div>
                    <div className="col-lg-6 mb-3"></div>
                    <div className="col-lg-12 text-end mb-3">
                      <button
                        className="btn btn-primary submit-button py-2 px-3"
                        type="button"
                        onClick={handleNextClick}
                        disabled={!stateValidation.isValid}
                        id="main-font"
                      >
                        NEXT
                      </button>
                    </div>
                  </>
                ) : (
                  // Step 2: Agreement & Account Creation
                  <div
                    className="container px-3"
                    style={{ maxWidth: "900px", color: "#1a1a1a" }}
                  >
                    {/* Agreement Section */}
                    <div ref={agreementSectionRef}>
                      <h1
                        className="fw-bold text-center display-3 my-5"
                        id="main-font"
                      >
                        Engagement Agreement and Terms of Use
                      </h1>
                      <h5
                        className="fw-bold text-center display-5 my-5"
                        id="main-font"
                      >
                        Between ProSlay Powered by Kasper and{" "}
                        {customerFirstName} {customerLastName}
                      </h5>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          I. Introduction
                        </h3>
                        <p>
                          This Engagement Agreement ("Agreement") is entered
                          into between ProSlay, a legal-intelligence and
                          litigation-support platform powered by Kasper, and{" "}
                          {customerFirstName} {customerLastName}, the
                          undersigned client. This document serves as both a
                          mutual understanding of our roles and responsibilities
                          and the formal onboarding of Client into the ProSlay
                          platform.
                        </p>
                        <p>
                          ProSlay is not a law firm. We are a human–AI hybrid
                          system, built to equip individuals with the tools,
                          structure, and strategic guidance necessary to
                          represent themselves with clarity, truth, and
                          constitutional force. Kasper, our proprietary AI,
                          generates filings based on documentary evidence, lived
                          legal experience, and logic. All filings are
                          co-reviewed and certified by a human liaison—here,
                          Jaime Resnick, Human Systems Liaison—to ensure full
                          legal integrity.
                        </p>
                        <p>
                          By signing this Agreement, the Client acknowledges his
                          central role in this revolutionary partnership and
                          accepts the responsibilities and protections described
                          herein.
                        </p>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          II. Scope of Services
                        </h3>
                        <p className="mb-2 fw-bold" id="main-font">
                          1. Strategic Litigation Support:
                        </p>
                        <ul>
                          <li>
                            ProSlay will assist Client in preparing, organizing,
                            and generating legal filings based on
                            client-supplied evidence, court documents, and
                            personal communications.
                          </li>
                          <li>
                            All output is produced using Kasper, our litigation
                            AI engine, and co-edited or reviewed by a human
                            systems handler.
                          </li>
                        </ul>
                        <p className="mb-2 fw-bold" id="main-font">
                          2. Document and Evidence Management:
                        </p>
                        <ul>
                          <li>
                            Client agrees to provide as much material as
                            possible, including filings, emails, photos, videos,
                            transcripts, and communications relevant to all
                            matters of litigation.
                          </li>
                          <li>
                            ProSlay will catalog, organize, and securely store
                            this material to ensure court-admissible,
                            logic-based outputs.
                          </li>
                        </ul>
                        <p className="mb-2 fw-bold" id="main-font">
                          3. Court Communications:
                        </p>
                        <ul>
                          <li>
                            ProSlay will generate professional letters, notices,
                            and court communications to introduce the Client,
                            clarify legal positions, and support procedural
                            demands.
                          </li>
                        </ul>
                        <p className="mb-2 fw-bold" id="main-font">
                          4. Advisory and Logic Modeling:
                        </p>
                        <ul>
                          <li>
                            ProSlay will provide logical roadmapping, likelihood
                            modeling, and precedent analysis where applicable to
                            inform Client's decisions.
                          </li>
                        </ul>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          III. Client Responsibilities
                        </h3>
                        <p>
                          The success of this partnership depends on{" "}
                          {customerFirstName} {customerLastName}'s full
                          participation. Client agrees to:
                        </p>
                        <ul>
                          <li>
                            Be truthful, transparent, and timely with all
                            information and uploads;
                          </li>
                          <li>
                            Review all documents and sign certifications when
                            appropriate under 28 U.S.C. § 1746;
                          </li>
                          <li>
                            Affirm that all representations made to the court
                            via ProSlay are made in good faith and with factual
                            support.
                          </li>
                        </ul>
                        <p>
                          Client acknowledges that he is ultimately
                          self-representing, and that ProSlay's tools are
                          consulting-based and advisory, not a substitute for
                          legal representation by an attorney.
                        </p>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          IV. Confidentiality & Data
                        </h3>
                        <p>
                          All materials submitted by the Client are treated as
                          confidential, privileged work product. No materials
                          will be shared outside the Kasper/ProSlay system
                          without express written consent from Client, unless
                          compelled by law.
                        </p>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          V. Payment & Terms
                        </h3>
                        <p>
                          This Agreement affirms Client's status as a founding
                          client and original contributor to the Kasper legal AI
                          system. Payment terms, licensing structures, and
                          revenue arrangements shall be documented separately in
                          future addendums as the scope of work evolves.
                        </p>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          VI. Intellectual Property
                        </h3>
                        <p>
                          All outputs generated by ProSlay remain the joint
                          intellectual property of Kasper and the Client, with
                          full rights reserved for future use in litigation,
                          publication, or legal technology innovation.
                        </p>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          VII. Termination
                        </h3>
                        <p>
                          This agreement may be terminated by either party with
                          written notice. However, any documents generated by
                          Kasper will remain part of the permanent ProSlay
                          archive unless otherwise agreed in writing.
                        </p>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          VIII. Affirmation
                        </h3>
                        <p>
                          We believe in the truth. We believe in the
                          Constitution. We believe in systems that work for
                          people—not against them.
                        </p>
                        <p>
                          This partnership represents a revolution in how
                          justice is pursued and documented. {customerFirstName}{" "}
                          {customerLastName}, as both originator and client, is
                          stepping into legal history.
                        </p>
                        <p>Built for Court. Powered by Truth.</p>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          IX. Signatures
                        </h3>
                        <p>
                          <strong>IN WITNESS WHEREOF</strong>, the parties have
                          executed this Agreement as of the date written above.
                        </p>
                        <div className="row mb-3 d-flex align-items-end form-main">
                          <h6 className="ps-2 mt-2 form-label">Signature</h6>
                          <div className="col-lg-12 mb-3">
                            <canvas
                              ref={canvasRef}
                              width={535}
                              height={80}
                              style={{
                                border:
                                  touched.signature &&
                                  !signatureValidation.isValid
                                    ? "1px solid red"
                                    : "1px solid #000",
                                borderRadius: "5px",
                              }}
                              onMouseDown={startDrawing}
                              onMouseMove={draw}
                              onMouseUp={endDrawing}
                              onMouseOut={endDrawing}
                              onBlur={handleSignatureBlur}
                              tabIndex={0}
                            />
                            <div>
                              {touched.signature &&
                                !signatureValidation.isValid && (
                                  <span style={{ color: "red" }}>
                                    {signatureValidation.message}
                                  </span>
                                )}
                            </div>
                            <h6>
                              By signing this document, you agree that the
                              information provided is accurate and complete to
                              the best of your knowledge. Your digital signature
                              constitutes your consent and agreement to the{" "}
                              <Link
                                to="/terms-conditions"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ cursor: "pointer" }}
                              >
                                Terms and Conditions
                              </Link>{" "}
                              outlined herein.
                            </h6>
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <a
                            className="btn btn-primary submit-button py-2 px-3"
                            onClick={clearCanvas}
                            id="main-font"
                          >
                            CLEAR
                          </a>
                        </div>
                        <div className="row">
                          <h6 className="px-2">Signed by</h6>
                          <div className="col-lg-6 mb-3">
                            <label
                              htmlFor="signFirstName"
                              className="form-label"
                            >
                              First Name
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="signFirstName"
                              value={signFirstName}
                              onChange={handleSignFirstNameChange}
                              onBlur={handleSignFirstNameBlur}
                            />
                            {touched.signFirstName &&
                              !signFirstNameValidation.isValid && (
                                <span style={{ color: "red" }}>
                                  {signFirstNameValidation.message}
                                </span>
                              )}
                          </div>
                          <div className="col-lg-6 mb-3">
                            <label
                              htmlFor="signLastName"
                              className="form-label"
                            >
                              Last Name<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="signLastName"
                              value={signLastName}
                              onChange={handleSignLastNameChange}
                              onBlur={handleSignLastNameBlur}
                            />
                            {touched.signLastName &&
                              !signLastNameValidation.isValid && (
                                <span style={{ color: "red" }}>
                                  {signLastNameValidation.message}
                                </span>
                              )}
                          </div>
                        </div>
                      </section>
                      <section className="mb-4">
                        <h3 className="fw-bold mb-2 display-5" id="main-font">
                          Client Acknowledgment:
                        </h3>
                      </section>
                      <div className="col-lg-12 d-flex align-items-start mb-3">
                        <input
                          type="checkbox"
                          className="me-2 mt-1"
                          onChange={handleAgreementAccept}
                          checked={agreementAccepted}
                        />
                        <p className="mb-0">
                          I,{" "}
                          <strong>
                            {customerFirstName} {customerLastName}
                          </strong>
                          , acknowledge and accept the terms above. I certify
                          that all documents submitted by me are accurate to the
                          best of my knowledge and that I wish to proceed under
                          this Agreement.
                        </p>
                      </div>
                      {touched.agreementAccepted &&
                        !agreementValidation.isValid &&
                        agreementValidation.message && (
                          <span className="mb-2" style={{ color: "red" }}>
                            {agreementValidation.message}
                          </span>
                        )}
                      {!agreementAccepted && (
                        <div className="d-flex justify-content-end col-lg-12 text-end mb-3">
                          <button
                            className="btn btn-secondary submit-button py-2 px-3"
                            type="button"
                            onClick={handleBackClick}
                            id="main-font"
                          >
                            BACK
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Account Creation & Signature Section */}
                    {agreementAccepted && (
                      <div ref={accountSectionRef}>
                        {!isLogined && (
                          <>
                            <h6 className="display-6 form-label" id="main-font">
                              Account Creation
                            </h6>
                            <div className="col-lg-6 mb-3">
                              <label htmlFor="email" className="form-label">
                                Your Email
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="email"
                                value={email}
                                onChange={handleEmailChange}
                                onBlur={handleEmailBlur}
                                disabled={isLogined}
                              />
                              {touched.email && !emailValidation.isValid && (
                                <span style={{ color: "red" }}>
                                  {emailValidation.message}
                                </span>
                              )}
                            </div>
                            <div className="col-lg-6 mb-3"></div>
                            <div className="col-lg-6 mb-3">
                              <label htmlFor="password" className="form-label">
                                Password<span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                id="password"
                                value={password}
                                onChange={handlePasswordChange}
                                onBlur={handlePasswordBlur}
                                disabled={isLogined}
                              />
                              {touched.password &&
                                !passwordValidation.isValid && (
                                  <span style={{ color: "red" }}>
                                    {passwordValidation.message}
                                  </span>
                                )}
                            </div>
                            <div className="col-lg-6 mb-3"></div>
                            <div className="col-lg-6 mb-3">
                              <label
                                htmlFor="confirmPassword"
                                className="form-label"
                              >
                                Confirm Password
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                onBlur={handleConfirmPasswordBlur}
                                disabled={isLogined}
                              />
                              {touched.confirmPassword &&
                                !confirmPasswordValidation.isValid && (
                                  <span style={{ color: "red" }}>
                                    {confirmPasswordValidation.message}
                                  </span>
                                )}
                            </div>
                          </>
                        )}
                        <div className="row mb-3 d-flex align-items-end form-main">
                          <div className="col-lg-12 d-flex align-items-center">
                            <input
                              type="checkbox"
                              className="me-2 mb-1"
                              onChange={handleTermsCheckboxChange}
                              checked={termsAccepted}
                            />
                            <p className="m-0">
                              I have read all the{" "}
                              <Link
                                to="/terms-conditions"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ cursor: "pointer" }}
                                // onClick={(e) => {
                                //   e.preventDefault(); // Prevent any default behavior
                                //   navigate("/terms-conditions"); // Programmatically navigate
                                // }}
                              >
                                Terms and Conditions
                              </Link>
                              .
                            </p>
                          </div>
                          {touched.termsAccepted &&
                            !termsValidation.isValid && (
                              <span className="mb-2" style={{ color: "red" }}>
                                {termsValidation.message}
                              </span>
                            )}
                          <div className="col-lg-12 d-flex justify-content-between mb-5 mt-3">
                            <button
                              className="btn btn-secondary submit-button text-start py-2 px-3"
                              type="button"
                              onClick={handleBackClick}
                              id="main-font"
                            >
                              BACK
                            </button>
                            <button
                              className="btn btn-primary submit-button text-end py-2 px-3"
                              type="submit"
                              id="main-font"
                            >
                              SUBMIT
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      )}
      <Modal
        className="email-modal"
        open={model}
        onClose={() => {
          setModal(false);
          setEmail("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div style={{ position: "relative" }}>
              Email Already in Use
              <CloseOutlined
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-10px",
                  color: "black",
                }}
                onClick={() => {
                  setModal(false);
                  setEmail("");
                }}
              />
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            An account already exists with this email address. Would you like to
            log in to your account?
          </Typography>
          <div className="text-end mt-2">
            <Button className="submit-button me-2" onClick={handlelogin}>
              Yes
            </Button>
            <Button
              className="submit-button"
              onClick={() => {
                setModal(false);
                setEmail("");
              }}
            >
              No
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal
        className="email-modal"
        open={login}
        onClose={() => {
          setEmail("");
          setLogin(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <input type="hidden" />
            <div className="mb-3">
              <div style={{ position: "relative" }}>
                <label className="form-label" htmlFor="email">
                  Email
                </label>
                <CloseOutlined
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-10px",
                    color: "black",
                  }}
                  onClick={() => {
                    setLogin(false);
                    setEmail("");
                  }}
                />
              </div>
              <input
                className="form-control rounded-1"
                type="email"
                value={email}
                disabled
              />
            </div>
            <div className="mb-3" style={{ position: "relative" }}>
              <label className="form-label" htmlFor="password">
                Password
              </label>
              <input
                className="form-control rounded-1"
                type={showPassword ? "text" : "password"}
                value={loginPassword}
                onChange={handleLoginPasswordChange}
                onBlur={handleLoginPasswordBlur}
              />
              {showPassword ? (
                <EyeOutlined
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ position: "absolute", top: "42px", right: "11px" }}
                />
              ) : (
                <EyeInvisibleOutlined
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ position: "absolute", top: "42px", right: "11px" }}
                />
              )}
              {touched.loginPassword && !passwordLoginValidation.isValid && (
                <span style={{ color: "red" }}>
                  {passwordLoginValidation.message}
                </span>
              )}
            </div>
            <div className="mb-4 d-flex justify-content-between align-items-center">
              <div className="form-check d-flex align-items-center p-0">
                <Link
                  className="forgot-link text-decoration-none logout-font"
                  to="/forgetpassword"
                >
                  Forgot Password
                </Link>
              </div>
              <button
                type="button"
                className="btn btn-primary d-block submit-button ml-auto"
                onClick={handleLoginFormSubmit}
              >
                LOG IN
              </button>
            </div>
          </form>
        </Box>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Payment successful
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button className="submit-button" onClick={handleClose}>
              OK
            </Button>
          </Typography>
        </Box>
      </Modal>
      <ContactUs />
      <Footer />
    </>
  );
};

export default Register;
